import React from 'react'
import Page from '../Page'

const HighI = ({ testResult }) => {
  return (
    <>
      <Page
        testResult={testResult}
        title="معرفی الگوی رفتاری High I افراد اثرگذار، الهام‌بخش و اجتماعی"
      >
        <p className="text-gray-800 leading-7">
          الگوی رفتاری   High I یکی از گرم‌ترین و پرانرژی‌ترین الگوهای رفتاری در مدل  DISC است. حرف  Iدر این مدل مخفف  Influenceبه معنای تأثیرگذاری است، و دقیقاً همین ویژگی، محور اصلی شخصیت این افراد است.
          افراد با الگوی  High I معمولاً خوش‌صحبت، برون‌گرا، با روابط عمومی بالا،
          پر از هیجان و علاقه‌مند به تعاملات اجتماعی هستند. آن‌ها به راحتی
          با دیگران ارتباط می‌گیرند، در جمع‌ها می‌درخشند، و معمولاً در مرکز
          توجه قرار دارند. علاقه‌مندی عمیق به دیده‌شدن و تحسین شدن، آن‌ها
          را به سمت فضاهای پرتعامل، شاد، هیجان‌انگیز و پویایی سوق می‌دهد.
        </p>

        <p className="text-gray-800 leading-7">
          این افراد، اغلب الهام‌بخش تیم‌ها هستند؛ در جمع‌ها شور ایجاد می‌کنند و حتی اگر توانایی تخصصی‌شان پایین‌تر باشد، با انرژی مثبت، انگیزه، خلاقیت و اشتیاق خود، دیگران را به حرکت در‌می‌آورند.
          اما در کنار این نقاط قوت،  High I ها معمولاً در پیگیری مستمر، تمرکز بر جزئیات، نظم شخصی، و مدیریت زمان چالش دارند. برای این افراد، شروع کار آسان است، اما ادامه و پایان‌بندی، نیاز به پشتیبانی یا همکاری با تیپ‌های مکمل دارد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رفتار بیرونی یک فرد High I چگونه دیده می‌شود؟"
      >
        <p className="text-gray-800 leading-7">
          پرانرژی، پرحرف، خوش‌پوش و خوش‌رو
          خلاق و باذوق در ایده‌پردازی
          مشتاق شروع کارهای جدید
          معمولاً درگیر چند پروژه همزمان
          ممکن است از موضوعی به موضوع دیگر بپرد و تمرکز بلندمدت نداشته باشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="کجاها این تیپ شخصیتی می‌درخشد؟"
      >
        <p className="text-gray-800 leading-7">
          در مشاغلی که نیاز به روابط انسانی، شور و هیجان، گفت‌وگو، فروش، سخنرانی، آموزش یا اجرا وجود دارد،  High Iها می‌توانند فوق‌العاده عمل کنند. همچنین در تیم‌هایی که نیاز به روحیه، انگیزه، همدلی و خلاقیت است، حضور یک  High I ضروری است.
          وقتی با فردی مواجه شدید که در جلسه اول با همه گرم می‌گیرد، لبخند به لب دارد، شروع‌کننده گفتگوست، و ایده‌های زیادی دارد ولی جزئیات برایش کسل‌کننده است، به احتمال زیاد با یک  High I طرف هستید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="معرفی فیلم"
      >
        <p className="text-gray-800 leading-7">
          فیلم Catch Me If You Can اگه می‌تونی منو بگیر، با بازی لئوناردو دی‌کاپریو شخصیت یک  High I را به‌خوبی نمایش می‌دهد. کسی که با قدرت کلام، تأثیرگذاری، شوخ‌طبعی و جذابیت شخصی، محیط‌ها را تغییر می‌دهد، ولی در ساختار و نظم، مشکل دارد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری High I"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ  High I از نظر رفتاری دارای ترکیبی از شور، تحرک، هیجان، ارتباط‌محوری و خوش‌بینی هستند. آن‌ها به جای اینکه مانند تیپ C روی عدد و منطق تمرکز کنند یا مثل تیپ D دنبال کنترل و نتیجه باشند، بیشتر به تأثیرگذاری بر دیگران از طریق ارتباط و احساس علاقه‌مندند.
          درک این ابعاد به اشخاص کمک می‌کند تا الگوی رفتاری فرد را
          سریع‌تر تشخیص دهند و در فرآیند هدایت و آموزش، بر اساس
          همین خصوصیات عمل کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="1. اثرگذاری اجتماعی Influence"
      >
        <p className="text-gray-800 leading-7">
          اصلی‌ترین بعد رفتاری  High I تأثیرگذاری از طریق ارتباطات بین‌فردی است. آن‌ها با شوخ‌طبعی، داستان‌سرایی، لبخند و انرژی مثبت، به راحتی نظر دیگران را جلب می‌کنند و فضای خشک را تبدیل به صحنه‌ای زنده می‌کنند.
          مثال: در یک جلسه کاری که همه خسته و بی‌انگیزه هستند، فرد  High I ممکن است با یک شوخی یا داستان جذاب، حال فضا را عوض کند و مشارکت‌ها را بالا ببرد.

        </p>
      </Page>

      <Page
        testResult={testResult}
        title="2. اشتیاق و هیجان در رفتار"
      >
        <p className="text-gray-800 leading-7">
          High Iها رفتاری پرجنب‌وجوش و گاه شلوغ دارند. دست‌هایشان زیاد حرکت می‌کند، صدایشان بالا و پایین می‌رود، و معمولاً از نشستن طولانی بیزارند. آن‌ها ترجیح می‌دهند وسط بحث باشند تا اینکه بیرون از ماجرا نظاره‌گر باقی بمانند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="3. تمرکز بر روابط، نه ساختار"
      >
        <p className="text-gray-800 leading-7">
          برای  High Iها، مهم این است که «با چه کسی» کار می‌کنند، نه «چه کاری». آن‌ها تیم‌محور، رابطه‌محور و مشتاق به همکاری هستند، حتی اگر ساختار کار شفاف نباشد.
          یادآوری کاربردی برای مدیران: اگر به فرد  High I فقط وظیفه بدهید ولی فضای ارتباطی و انگیزشی ندهید، عملکردش افت می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="4. نیاز به تأیید و توجه"
      >
        <p className="text-gray-800 leading-7">
          یکی از ابعاد عمیق تیپ  High I، نیاز به دیده‌شدن، شنیده‌شدن و تحسین‌شدن است. او باید احساس کند که برای دیگران مهم است. اگر این نیاز نادیده گرفته شود، ممکن است دچار افت انرژی، خستگی یا حتی رفتارهای نمایشی شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="5. خلاق ولی گاه ناپایدار"
      >
        <p className="text-gray-800 leading-7">
          High Iها ذهن خلاقی دارند. ایده‌های نو و راه‌حل‌های جذاب زیادی ارائه می‌دهند. اما ممکن است در پیگیری و اجرای آن‌ها دچار مشکل شوند. دلیل؟ حوصله کارهای تکراری و جزئیات را ندارند
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="6. اجتناب از تعارض و انتقاد مستقیم"
      >
        <p className="text-gray-800 leading-7">
          این افراد از درگیری مستقیم یا فضاهای پرتنش دوری می‌کنند. اگر با آن‌ها با لحن خشن یا قضاوت‌گر صحبت شود، معمولاً یا واکنش هیجانی نشان می‌دهند یا سکوت می‌کنند و فاصله می‌گیرند.
          اگر شما با فردی مواجه هستید که در اولین برخورد، لبخند بر لب دارد، سریع گرم می‌گیرد، از خاطره‌ها و ایده‌ها می‌گوید، برای صحبت دیگران وسط‌پری می‌کند، و در عین حال هنوز پروژه‌ای را تمام نکرده، احتمالاً با یک  High I طرف هستید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تشریح الگوی رفتاری  High I"
      >
        <p className="text-gray-800 leading-7">
          <div className="text-gray-800 leading-7 space-y-4">
            <p>
              تیپ High I، شخصیتی الهام‌بخش، پرانرژی و مردم‌محور دارد. این افراد به‌طور طبیعی عاشق ارتباطند و با زبان، احساس و انرژی خود، دیگران را مجذوب می‌کنند. اما برای شناخت دقیق این تیپ، باید از پشت پرده لبخندها و شوخ‌طبعی‌ها هم آگاه باشیم. High I فقط یک شخصیت شاد نیست، بلکه فردی است که عمیقاً به تأثیرگذاری مثبت بر اطرافیان نیاز دارد.
            </p>

            <div className="space-y-3">
              <div>
                <h4 className="font-semibold text-gray-800 mb-2">۱. هدایت‌گر از طریق احساس، نه دستور</h4>
                <p>
                  افراد High I ترجیح می‌دهند دیگران را با اشتیاق، الهام و دلگرمی هدایت کنند، نه با دستور مستقیم یا اجبار. آن‌ها انگیزه‌بخش‌اند، اما نه ساختاردهنده. به همین دلیل، در جایگاه‌های رهبری، بیشتر نقش «الهام‌بخش تیم» را دارند تا «مدیر دقیق اجرایی».
                </p>
              </div>

              <div>
                <h4 className="font-semibold text-gray-800 mb-2">۲. عاشق آغاز، گریزان از پایان‌بندی</h4>
                <p>
                  شروع پروژه‌های جدید برای این افراد هیجان‌انگیز است. آن‌ها با انرژی وارد می‌شوند، ایده می‌سازند، دیگران را جذب می‌کنند؛ اما وقتی پروژه وارد فاز اجرا، پیگیری، گزارش‌نویسی و جزئیات می‌شود، معمولاً اشتیاق‌شان افت می‌کند.
                </p>
                <div className="mt-2 p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>مثال کاربردی:</strong> فرد High I در یک شرکت تبلیغاتی ممکن است کمپین بسیار جذابی طراحی کند، اما برای بررسی نرخ بازگشت سرمایه یا داده‌های آماری نیاز به کمک دارد.
                  </p>
                </div>
              </div>

              <div>
                <h4 className="font-semibold text-gray-800 mb-2">۳. تأیید بیرونی، سوخت روانی آن‌هاست</h4>
                <p>
                  برخلاف برخی تیپ‌ها که با هدف‌گذاری درونی رشد می‌کنند مثل High D یا C، تیپ I رشدش را در آینه نگاه دیگران می‌بیند. اگر دیده شود، تشویق شود، در جمع مطرح شود، اوج می‌گیرد. اگر نادیده گرفته شود، ممکن است سرخورده، خاموش یا حتی نمایشی شود.
                </p>
              </div>

            </div>
          </div>

        </p>
      </Page>

      <Page
        testResult={testResult}
      >
        <div>
          <h4 className="font-semibold text-gray-800 mb-2">۴. واژه‌های مورد علاقه این تیپ</h4>
          <p className="mb-2 text-gray-800">این جملات برای یک High I مثل شارژر برای موبایل است:</p>
          <ul className="list-disc list-inside space-y-1 text-gray-700">
            <li>«باور کن می‌تونی»</li>
            <li>«فوق‌العاده‌ای!»</li>
            <li>«خیلی دوستت دارن»</li>
            <li>«تو همیشه انرژی خوبی می‌دی»</li>
            <li>«بی‌نظیری!»</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-gray-800 mb-2">۵. اهل صلح و نه جنگ</h4>
          <p className='text-gray-800'>
            High I در روابط عاطفی و کاری، به شدت صلح‌طلب است. او از تعارض یا فضاهای سرد و رسمی فراری است. اگر با او به‌صورت تند یا قاطع صحبت شود، ممکن است دفاعی، هیجانی یا حتی کودکانه رفتار کند.
          </p>
        </div>

        <div>
          <h4 className="font-semibold text-gray-800 mb-2">۶. ضعف در تمرکز و تصمیم‌گیری منطقی</h4>
          <p className='text-gray-800'>
            این تیپ معمولاً با احساس تصمیم می‌گیرد و اگر انرژی اطراف پایین باشد، دچار بی‌میلی یا شتاب‌زدگی می‌شود. تحلیل هزینه-فایده، زمان‌بندی، یا اولویت‌بندی، جزو نقاط ضعف رایج اوست، مگر اینکه آموزش دیده یا با تیپ C در کنار خود همراه باشد.
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="انگیزه شما در تیپ High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            افراد با الگوی High I بیش از هر چیز از ارتباط، دیده‌شدن، تأثیرگذاری و تحسین انرژی می‌گیرند. آن‌ها مانند موتورهایی هستند که با «بازخورد مثبت» روشن می‌مانند. انگیزه در این تیپ، نه‌تنها برای کار بلکه برای زندگی، رابطه، آموزش و حتی سرگرمی به‌شدت به تأیید بیرونی و تعامل انسانی وابسته است.
          </p>

          <div className="space-y-3">
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۱. دیده شدن = انگیزه گرفتن</h4>
              <p>
                High Iها دوست دارند مرکز توجه باشند. نه لزوماً از جنس خودنمایی، بلکه از این منظر که اگر در جمع نباشند، احساس گم‌نامی و بی‌اثری می‌کنند. آن‌ها می‌خواهند حضورشان حس شود، صدایشان شنیده شود، و انرژی‌شان منتقل شود.
              </p>
              <div className="mt-2 p-3 bg-blue-50 rounded-lg">
                <p className="text-sm text-blue-800">
                  <strong>مثال:</strong> اگر در یک کلاس آنلاین مشارکتی، نام یک High I چند بار خوانده نشود یا او فرصتی برای صحبت نداشته باشد، ممکن است انگیزه‌اش به‌سرعت افت کند.
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۲. تحسین و بازخورد مثبت، غذای روانی اوست</h4>
              <p className="mb-2">
                این افراد پس از انجام هر فعالیتی، از ارائه در جلسه گرفته تا انجام یک کار کوچک، منتظرند بازخورد بگیرند. اگر تشویق شوند، ده برابر انرژی می‌گیرند؛ اگر نادیده گرفته شوند، ممکن است ناامید یا بی‌انگیزه شوند.
              </p>
              <p className="text-sm italic text-gray-600">
                حتی یک جمله مثبت ساده مثل «دمت گرم، خیلی خوب بود!» می‌تواند روز یک High I را بسازد.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۳. هیجان = محرک عمل</h4>
              <p>
                High Iها با کارهای یکنواخت، آرام و ساختارمند انگیزه نمی‌گیرند. آن‌ها باید احساس کنند کاری که انجام می‌دهند، هیجان‌انگیز است. اگر فضای کاری خیلی جدی، بی‌تحرک یا رسمی باشد، این تیپ به‌مرور دچار افت کارایی می‌شود.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۴. ایده‌های نو، پروژه‌های تازه، فضاهای جدید</h4>
              <p>
                تیپ I از تکرار خسته می‌شود. دیدن «امکان جدید»، «فرصت تازه» یا «چالش متفاوت» انگیزه آن‌ها را بالا می‌برد. حتی ممکن است فقط به خاطر جذابیت یک ایده وارد پروژه‌ای شوند، نه بخاطر مزایای منطقی آن.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۵. ارتباط مثبت با دیگران</h4>
              <p>
                هیچ چیز مثل یک تیم دوستانه، فضای خنده‌دار و تعامل سالم، نمی‌تواند High I را انگیزه‌مند کند. در واقع، این تیپ انگیزه خود را از احساس تعلق به جمع می‌گیرد، نه الزام وظیفه.
              </p>
            </div>

          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
      >
        <div>
          <h4 className="font-semibold text-gray-800 mb-2">۶. الهام‌گیری از دیگران (نه رقابت‌جویی)</h4>
          <p>
            برخلاف تیپ D که با رقابت و پیروزی شارژ می‌شود، High I انگیزه‌اش را از الهام گرفتن از افراد محبوب یا پرانرژی می‌گیرد. حضور افراد مثبت‌نگر در اطرافش، موتور محرکه ذهن و احساس اوست.
          </p>
        </div>
        <h3 className="font-semibold text-gray-800 mb-3">جمع‌بندی آموزشی</h3>
        <p className="mb-3">برای بالا نگه‌داشتن انگیزه یک High I:</p>
        <ul className="space-y-2 list-disc list-inside text-gray-700">
          <li>بازخوردهای سریع و مثبت بدهید</li>
          <li>موقعیت‌هایی برای تعامل و بروز ایده فراهم کنید</li>
          <li>او را در فعالیت‌هایی با تنوع و تماس انسانی درگیر کنید</li>
          <li>از او درباره احساسش نسبت به پروژه بپرسید، نه فقط درباره نتیجه</li>
          <li className="font-semibold text-blue-800">و مهم‌تر از همه: بگذارید بدرخشد</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ High I"
      >
        <p className="text-gray-800 leading-7">
          <div className="text-gray-800 leading-7 space-y-4">
            <p>
              افراد با الگوی High I به شکل ذاتی، نیروی محرکه تیم در فاز شروع هستند. آن‌ها محیط کاری را گرم، پرانرژی و متنوع می‌پسندند. اما برخی از عادت‌های رفتاری و شغلی آن‌ها ممکن است در غیاب هدایت درست، به نقاط ضعف تبدیل شود. درک این الگوها کمک می‌کند تا در محیط کار، به جای درگیر شدن با شخصیتشان، از آن به‌درستی بهره بگیریم.
            </p>

            <div className="space-y-3">
              <div className='text-gray-800'>
                <h4 className="font-semibold text-gray-800 mb-2">۱. عاشق شروع، بی‌قرار در ادامه</h4>
                <p>
                  High Iها در شروع پروژه‌ها، جلسه‌ها، ارتباطات یا ایده‌ها بسیار قوی‌اند. اما همان‌طور که قبلاً هم اشاره شد، در ادامه مسیر، مخصوصاً زمانی که کار وارد فاز اجرا، مستندسازی یا تحلیل جزئیات می‌شود، اغلب انگیزه‌شان کاهش می‌یابد.
                </p>
                <div className="mt-2 p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>مثال:</strong> ممکن است فرد High I با شور و هیجان یک کمپین تبلیغاتی را آغاز کند، اما زمانی که نوبت نوشتن گزارش یا پاسخ دادن به ایمیل‌ها می‌رسد، اهمال‌کاری کند.
                  </p>
                </div>
              </div>

              <div className='text-gray-800'>
                <h4 className="font-semibold text-gray-800 mb-2">۲. بسیار اجتماعی و گروه‌محور</h4>
                <p>
                  آن‌ها بهترین عملکرد را زمانی دارند که در یک تیم، تعامل بالا، شوخی، لبخند و ارتباط جاری باشد. جلسات گروهی، فعالیت‌های تیمی، کار در محیط‌های شلوغ و پرتحرک برایشان جذاب است.
                </p>
              </div>

              <div className='text-gray-800'>
                <h4 className="font-semibold text-gray-800 mb-2">۳. چالش در مدیریت زمان و اولویت‌بندی</h4>
                <p className="mb-2">
                  High I معمولاً خوش‌بینانه برنامه‌ریزی می‌کند: فکر می‌کند همه چیز سریع و بدون مشکل پیش خواهد رفت. همین موضوع باعث می‌شود وظایفش دیر انجام شود یا به تعویق بیفتد.
                </p>
                <div className="mt-2 p-3 bg-green-50 rounded-lg border-r-4 border-green-500">
                  <p className="text-sm text-green-800">
                    <strong>راهکار:</strong> استفاده از ابزارهای یادآوری، لیست‌های کوتاه، جلسات روزانه مرور برنامه‌ها و حتی مربی یا همکار پیگیر.
                  </p>
                </div>
              </div>

              <div className='text-gray-800'>
                <h4 className="font-semibold text-gray-800 mb-2">۴. جزئیات = خستگی ذهنی</h4>
                <p>
                  وظایفی که نیاز به دقت بالا، تمرکز، کار با داده‌ها یا بررسی جزئیات دارد، برای High I کسل‌کننده است. او بیشتر تصویر کلی را دوست دارد تا بررسی خط‌به‌خط جزئیات.
                </p>
              </div>
            </div>
          </div>

        </p>
      </Page>

      <Page
        testResult={testResult}
      >

        <div className='text-gray-800'>
          <h4 className="font-semibold text-gray-800 mb-2">۵. انگیزه‌مند در موقعیت‌های خلاقانه</h4>
          <p>
            اگر پروژه‌ای شامل خلاقیت، داستان‌پردازی، تولید محتوا، گفت‌وگو، ارائه، برندینگ یا تعامل انسانی باشد، High I می‌درخشد.
          </p>
        </div>

        <div className='text-gray-800'>
          <h4 className="font-semibold text-gray-800 mb-2">۶. تنوع‌طلبی رفتاری</h4>
          <p>
            High I اگر هر روز دقیقاً یک کار تکراری انجام دهد، خسته می‌شود. او نیاز دارد حس کند زندگی کاری‌اش پویاست و در حال تجربه چیزهای جدید است. این حس باید حتی درون یک پروژه نیز ایجاد شود.
          </p>
        </div>

        <div className='text-gray-800'>
          <h4 className="font-semibold text-gray-800 mb-2">۷. پاسخ‌دهی سریع، اما گاهی سطحی</h4>
          <p>
            این تیپ معمولاً سریع پاسخ می‌دهد، اما ممکن است عمق یا دقت کافی نداشته باشد. مثلاً در پیام‌رسانی‌های کاری، ایمیل‌ها یا جلسات، ممکن است خیلی زود بگوید «باشه!» ولی اجرای دقیق آن را فراموش کند یا اشتباه متوجه شود.
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های شما در تیپ High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            فرد High I دنیا را از پنجره‌ای رنگارنگ، خوش‌بینانه و انسانی می‌بیند. نگاه او به زندگی، کار و روابط، سرشار از انرژی مثبت، اعتماد به دیگران و تمرکز بر روابط بین‌فردی است. درک این دیدگاه به مربیان، مدیران و اطرافیان کمک می‌کند که با واقع‌بینی، هم از توانمندی‌های این تیپ بهره بگیرند و هم به رشد او کمک کنند.
          </p>

          <div className="space-y-3">
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۱. جهان جای هیجان‌انگیزی‌ست (اگر خشک نباشد!)</h4>
              <p>
                High I معتقد است که زندگی باید با هیجان، ارتباط، ماجراجویی و لذت همراه باشد. او با محیط‌های رسمی، ساختاری، یکنواخت و ساکت سازگار نیست و باور دارد که «شادی یک اصل است، نه پاداش».
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۲. هرکسی چیزی برای گفتن دارد</h4>
              <p>
                از دید High I، هر فردی در ذات خود جذاب است و هر ارتباطی ارزش دارد. به همین دلیل، خیلی زود با دیگران گرم می‌گیرد، حتی اگر آن‌ها را نشناسد یا پیشینه خاصی نداشته باشند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۳. همه مرا دوست خواهند داشت (تا خلافش ثابت شود)</h4>
              <p>
                نگاه High I به روابط اغلب خوش‌بینانه است. او معمولاً با این پیش‌فرض وارد جمع می‌شود که «مرا خواهند پذیرفت» و اگر طرد یا بی‌توجهی ببیند، به‌شدت آسیب‌پذیر می‌شود.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۴. احساسات، راهنمای خوبی هستند (اما نه همیشه)</h4>
              <p>
                این تیپ، تصمیمات زیادی را با احساس می‌گیرد. اگر کسی حالش خوب باشد، برای او «قابل اعتماد» است. اگر جلسه‌ای انرژی داشته باشد، «موفق» است. این نگاه می‌تواند گمراه‌کننده باشد، مگر اینکه فرد یاد بگیرد با کمک تیپ‌های منطقی‌تر، نگاه تحلیلی‌تری هم وارد تصمیم‌گیری‌هایش کند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۵. اگر من خوشحال باشم، دیگران هم خوشحال خواهند شد</h4>
              <p>
                این باور بنیادین High Iهاست: اگر من انرژی خوب پخش کنم، حتماً تأثیرگذار خواهم بود. در بیشتر موارد این نگاه سازنده است، ولی گاهی باعث نادیده‌گرفتن واقعیت‌ها یا مشکلات می‌شود.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۶. اشتباهات، فاجعه نیستند</h4>
              <p>
                برخلاف تیپ‌هایی مثل High C که هر خطا را یک بحران می‌دانند، تیپ I اشتباه را بخشی از مسیر می‌داند. او حتی ممکن است با شوخی یا خلاقیت از کنار اشتباه بگذرد، که البته در محیط‌های دقیق و رسمی می‌تواند دردسرساز شود.
              </p>
            </div>
          </div>
        </div>
      </Page>


      <Page
        testResult={testResult}
      >
        <div>
          <h4 className="font-semibold text-gray-800 mb-2">۷. برای رسیدن به موفقیت، نیازی به سخت‌گیری نیست!</h4>
          <p>
            از دیدگاه یک High I، موفقیت زمانی ارزش دارد که همراه با شادی و لذت باشد. اگر کاری فقط نتیجه داشته باشد اما سخت، خشک یا بی‌روح باشد، از نظر او چندان جذاب نیست.
          </p>
        </div>
        <div className="mt-6 p-4 text-gray-800 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg border border-purple-200">
          <h3 className="font-semibold mb-3">جمع‌بندی آموزشی</h3>
          <p>
            High I دنیا را شبیه یک صحنه تئاتر پر از نور و حرکت می‌بیند. او ترجیح می‌دهد «در صحنه باشد» تا اینکه «پشت صحنه کار را مدیریت کند». پس اگر می‌خواهید با او همراه شوید، درک کنید که نگاهش همیشه به «انسان»، «احساس» و «تأثیرگذاری مثبت» معطوف است، نه الزاماً به داده، نظم یا نتیجه سریع.
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            برای افراد High I، اوقات فراغت فقط زمانی برای استراحت نیست، بلکه فرصتی است برای تخلیه انرژی، ارتباط، سرگرمی و بازسازی هیجانی. آن‌ها به‌جای سکوت و خلوت، اوقات فراغت را با خنده، جنب‌وجوش، جمع‌های دوستانه یا تجربه‌های تازه می‌گذرانند.
          </p>

          <div className="space-y-3">
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۱. تفریح اجتماعی، نه فردی</h4>
              <p>
                High Iها تفریحات گروهی را ترجیح می‌دهند: دورهمی، مهمانی، سفرهای دوستانه، بازی‌های جمعی، تماشای فیلم با جمع یا حتی گپ‌های طولانی و خودمانی. تنها ماندن طولانی‌مدت برای آن‌ها خسته‌کننده است.
              </p>
              <p className="mt-2">
                مثال: اگر بگویید «بیا با هم کوه برویم»، انرژی می‌گیرند؛ اما اگر بگویید «برو تنها کوه برو تا فکر کنی»، معمولاً انگیزه‌ای ندارند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۲. هیجان + ارتباط = تفریح ایده‌آل</h4>
              <p>
                آن‌ها عاشق تجربه چیزهای جدیدند، مخصوصاً اگر با دیگران همراه باشد. رفتن به کنسرت، پارک‌های هیجانی، کمپینگ‌های گروهی، بازی‌های رقابتی و حتی اجرا یا شرکت در نمایش‌ها برای آن‌ها جذاب است.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۳. علاقه به خلاقیت، هنر، اجرا</h4>
              <p>
                اوقات فراغت این تیپ، ممکن است صرف فعالیت‌هایی مثل اجرا در تیک‌تاک یا اینستاگرام، تولید ویدیو، نقاشی خلاقانه، آواز، نواختن موسیقی یا حتی ساخت پادکست شود؛ کاری که هم دیده شود، هم لذت ببرد.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۴. فرار از تنهایی یا محیط‌های خنثی</h4>
              <p>
                High Iها در محیط‌های بی‌تحرک، تکراری یا ساکت، خیلی زود دچار بی‌حوصلگی می‌شوند. سکوت اگر طولانی شود، برایشان نه آرامش‌بخش، بلکه انرژی‌گیر است.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۵. برنامه‌ریزی برای تفریح، نه صرفاً استراحت</h4>
              <p>
                وقتی High I می‌خواهد ریکاوری کند، اغلب به سراغ برنامه‌هایی با نشاط و هیجان می‌رود، نه سکوت و انزوا. حتی استراحتش هم معمولاً همراه با موسیقی، پادکست یا گپ و گفت است.
              </p>
            </div>
          </div>
        </div>
      </Page>


      <Page
        testResult={testResult}
      >

        <div >
          <h4 className="font-semibold text-gray-800 mb-2">فیلم‌های پیشنهادی برای درک اوقات فراغت تیپ I</h4>
          <p>
            <strong>Yes Man (مرد بله‌گو):</strong> نمایش روحیه تجربه‌گرایی و اجتماعی یک فرد High I
          </p>
          <p className="mt-2 text-gray-800">
            <strong>The Secret Life of Walter Mitty (زندگی پنهان والتر میتی):</strong> داستان مردی که با تخیل و فرار از روزمرگی، انرژی می‌گیرد.
          </p>
        </div>

        <div>
          <h4 className="font-semibold text-gray-800 mb-2">نکته مربیگری</h4>
          <p>
            اگر در فرآیند آموزش، هدایت یا کوچینگ یک High I هستید، برنامه‌های انگیزشی، سفرهای تیمی، بازی‌های گروهی یا حتی «چالش‌های سرگرم‌کننده» بهترین ابزار برای ایجاد پیوند و انگیزه در اوست. تفریح او همان مسیر یادگیری‌اش است.
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="تصمیم‌گیری در تیپ High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            تصمیم‌گیری برای افراد High I اغلب فرآیندی هیجانی، سریع و خوش‌بینانه است. آن‌ها تصمیم می‌گیرند همان‌طور که با دنیا ارتباط برقرار می‌کنند: با احساس، شور، شهود و توجه به جو بیرونی. در حالی‌که این سبک می‌تواند در بعضی موقعیت‌ها به موفقیت منجر شود، اما در موقعیت‌های حساس، مالی یا استراتژیک می‌تواند مخاطره‌آمیز باشد.
          </p>

          <div className="space-y-3">
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۱. هیجان‌محور، نه تحلیل‌محور</h4>
              <p>
                High I معمولاً از خود نمی‌پرسد «این تصمیم از نظر عدد و منطق درست است؟» بلکه می‌پرسد:
              </p>
              <p className="mt-2">
                «این تصمیم حس خوبی بهم می‌دهد؟ مردم چی می‌گویند؟ انرژی فضا چطوره؟»
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۲. تصمیم‌گیری تحت تأثیر جمع یا بازخورد دیگران</h4>
              <p>
                اگر جمعی از تصمیم حمایت کند یا اگر High I از طرف کسی که دوستش دارد تشویق شود، احتمال زیادی دارد بدون بررسی کامل، وارد ماجرا شود.
              </p>
              <p className="mt-2">
                مثال: ممکن است به دلیل شور یک دوست وارد سرمایه‌گذاری شود، بدون اینکه طرح را بررسی کند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۳. مشکل در بررسی پیامدهای بلندمدت</h4>
              <p>
                High I در لحظه تصمیم می‌گیرد و از جزئیات یا تأثیرات آینده چشم‌پوشی می‌کند. همین امر باعث می‌شود در بعضی پروژه‌ها بعداً با مسائل پیش‌بینی‌نشده مواجه شود.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۴. زود موافقت می‌کند، دیر پشیمان می‌شود</h4>
              <p>
                به دلیل خوش‌قلبی و تمایل به جلب رضایت دیگران، ممکن است خیلی سریع بگوید «باشه»، ولی بعداً متوجه شود که شرایط مناسبش نبوده.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-2">۵. اجتناب از تصمیمات چالشی یا تعارض‌زا</h4>
              <p>
                اگر تصمیمی با مخالفت یا تنش همراه باشد، High I ممکن است از گرفتن آن فرار کند، به تعویق بیندازد یا تصمیمی سطحی و بی‌اثر بگیرد تا «همه راضی بمانند».
              </p>
            </div>

          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
      >

        <div className='text-gray-800'>
          <h4 className="font-semibold text-gray-800 mb-2">پیشنهادات کاربردی برای بهبود تصمیم‌گیری</h4>
          <ul className="list-disc pr-5 space-y-2">
            <li>قبل از تصمیم‌گیری، احساسات را بنویسید و ۲۴ ساعت بعد بازبینی کنید.</li>
            <li>از تیپ‌های High C یا CS برای مشورت و بررسی منطق تصمیم استفاده کنید.</li>
            <li>پیامدهای کوتاه‌مدت و بلندمدت را روی کاغذ ترسیم کنید (نه فقط در ذهن نگه دارید).</li>
            <li>
              سه سؤال کلیدی از خود بپرسید:
              <ul className="list-decimal pr-5 mt-2 space-y-1">
                <li>اگر فردی غریبه این تصمیم را بگیرد، چه فکری می‌کنم؟</li>
                <li>در بدترین حالت ممکن، چه می‌شود؟</li>
                <li>آیا این تصمیم با اهداف بلندمدت من سازگار است؟</li>
              </ul>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-gray-800 mb-2">تمرین</h4>
          <p className='text-gray-800'>
            از شخص با تیپ High I بخواهید یک تصمیم اخیر خود را با مدل «فکت، فیدبک، فیلتر، فینال» تحلیل کند. این تمرین کمک می‌کند از هیجان صرف فاصله بگیرد و دیدگاه تحلیلی‌تری پیدا کند.
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            اگرچه افراد High I به‌صورت ذاتی تأثیرگذار، الهام‌بخش و محبوب هستند، اما برای رسیدن به عملکرد حرفه‌ای پایدار، لازم است برخی از نقاط ضعف رفتاری‌شان را بشناسند و با تمرین هدفمند، بهبود دهند. در ادامه، مجموعه‌ای از پیشنهادات برای رشد فردی، شغلی و اجتماعی این تیپ ارائه شده است.
          </p>

          <div className="space-y-4">
            <div>
              <h4 className="font-semibold mb-2">۱. تمرین تعهد تا پایان کار</h4>
              <p>
                به‌جای هیجان برای شروع، تمرکزتان را روی اتمام کار بگذارید. برای خود پاداش‌های کوچکی تعریف کنید که تنها در صورت «اتمام پروژه» دریافت می‌کنید.
              </p>
              <p className="mt-2">
                مثال: اگر محتوا می‌نویسید، تا وقتی کامل نشده آن را منتشر نکنید، حتی اگر ایده‌اش عالی باشد.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۲. برنامه‌ریزی روزانه و پیگیری کوتاه‌مدت</h4>
              <p>
                از ابزارهایی مثل تقویم دیجیتال، اپلیکیشن‌های برنامه‌ریزی یا مربی پیگیری استفاده کنید. بهتر است به‌جای برنامه‌های بلندمدت، برنامه‌هایی با اهداف ۳ یا ۷ روزه داشته باشید تا احساس تعویق نکنید.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۳. کاهش وابستگی به تحسین بیرونی</h4>
              <p>
                آگاهانه تمرین کنید کارهایی انجام دهید که کسی از آن‌ها خبردار نمی‌شود. مثلاً خواندن یک کتاب یا نوشتن یک متن برای دل خودتان. این تمرین، استقلال روانی شما را تقویت می‌کند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۴. ارتباط با افراد با تیپ مکمل</h4>
              <p>
                در اطراف خود افرادی از تیپ‌های C، S یا D داشته باشید که بتوانند با آرامش، منطق یا ساختار شما را همراهی کنند. از آن‌ها بازخورد بگیرید، حتی اگر گاهی خشک یا دقیق باشند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۵. توسعه مهارت «نه گفتن» و مدیریت هیجان</h4>
              <p>
                همه درخواست‌ها را با لبخند نپذیرید. جمله‌هایی مثل «الان اجازه بده فکر کنم» یا «بذار برنامه‌م رو بررسی کنم» راه‌حل‌های محترمانه برای نه گفتن هستند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۶. آگاهانه در جلسات بیشتر گوش دهید</h4>
              <p>
                تمرین کنید حداقل ۲ دقیقه بدون قطع‌کردن، به دیگران گوش دهید. این تمرین ساده، قدرت تمرکز، صبر و عمق تعامل شما را به‌شدت افزایش می‌دهد.
              </p>
            </div>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
      >
        <div className='text-gray-800 space-y-4'>
          <div>
            <h4 className="font-semibold mb-2">۷. تفکیک «هیجان لحظه» با «اهمیت واقعی» تصمیم‌ها</h4>
            <p>
              همیشه این سؤال را از خود بپرسید:
            </p>
            <p className="mt-2">
              «آیا این تصمیم فقط چون الان هیجان‌زده‌ام، خوب به‌نظر می‌رسد؟ یا واقعاً برای من مناسب است؟»
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۸. پرورش تمرکز با تکنیک پومودورو (Pomodoro)</h4>
            <p>
              با تنظیم تایمر برای ۲۵ دقیقه تمرکز و ۵ دقیقه استراحت، می‌توانید بهره‌وری خود را به‌شکل چشمگیری بالا ببرید. این روش مخصوص افرادی است که ذهن پرجهشی دارند.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۹. تحلیل رفتارهای گذشته، نه سرزنش آن‌ها</h4>
            <p>
              گاهی برای بهبود عملکرد، کافی‌ست چند تصمیم گذشته را تحلیل کنید. بنویسید چرا آن تصمیم را گرفتید، چه چیزی را درست دیدید و چه چیزی را نادیده گرفتید. این تمرین، بینش واقعی می‌دهد.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">جمع‌بندی</h4>
            <p>
              High Iها توانایی فوق‌العاده‌ای در روشن کردن فضای تیم دارند. اما اگر بخواهند فقط لامپ باشند و نه ژنراتور، در مسیر رشد متوقف می‌شوند. با تقویت تعهد، تمرکز، نه‌گویی و تحلیل، می‌توانند به تعادل درخشان بین «اثرگذاری» و «نتیجه‌سازی» برسند.
            </p>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت در تیپ High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            High Iها ذاتاً پرانرژی، خوش‌برخورد و تأثیرگذار هستند. اما موفقیت واقعی آن‌ها زمانی رقم می‌خورد که این ویژگی‌های ذاتی با رفتارهای مکمل مثل «تمرکز»، «تعهد»، «عمق» و «دقت» ترکیب شود. به عبارت دیگر، یک High I موفق، کسی نیست که فقط بدرخشد، بلکه کسی است که در کنار درخشش، دوام بیاورد و به ثمر برسد.
          </p>

          <div className="space-y-3">
            <div>
              <h4 className="font-semibold mb-2">۱. تداوم در اقدام</h4>
              <p>
                شروع برای شما ساده است. رمز موفقیت این است که درگیر «تداوم» شوید. حتی اگر هیجان‌تان کم شد، با برنامه، انگیزه‌سازی درونی یا همراهی با دیگران، مسیر را ادامه دهید.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۲. پذیرش بازخورد منفی بدون واکنش هیجانی</h4>
              <p>
                یاد بگیرید از انتقاد، درس بگیرید نه اینکه آن را حمله شخصی تلقی کنید. موفق‌ترین High Iها کسانی هستند که بازخوردهای سازنده را به‌جای دفاع، جذب می‌کنند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۳. صبر در مقابل تصمیم‌گیری سریع</h4>
              <p>
                پیش از هر تصمیم مهم، یک شب صبر کنید. این وقفه ساده، شما را از بسیاری انتخاب‌های هیجانی که بعداً پشیمانی می‌آورد نجات می‌دهد.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۴. تمرین عمق در گفتار و رفتار</h4>
              <p>
                محتوا مهم‌تر از جذابیت ظاهری است. سعی کنید در جلسات، علاوه بر فضای مثبت، ایده‌هایی عمیق، تحلیل‌هایی دقیق یا مشاهداتی تأمل‌برانگیز ارائه دهید. این کار باعث می‌شود اثرگذاری شما ماندگار شود.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۵. مدیریت انرژی، نه فقط استفاده از آن</h4>
              <p>
                شما منبع عظیمی از انرژی هستید؛ اما این انرژی باید هدفمند و زمان‌بندی‌شده باشد. تمرین کنید بدانید چه زمانی باید انرژی پخش کنید و چه زمانی باید شارژ شوید.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۶. ترکیب روابط با نتیجه</h4>
              <p>
                یکی از کلیدی‌ترین رموز موفقیت تیپ High I این است که روابطش را به ابزار پیشرفت تبدیل کند، نه فقط لذت لحظه‌ای. اگر یاد بگیرد چگونه از ارتباطات خود، شبکه حرفه‌ای و هم‌افزا بسازد، موفقیت‌های پایدارتری خواهد داشت.
              </p>
            </div>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
      >
        <div className="text-gray-800 space-y-4">
          <div>
            <h4 className="font-semibold mb-2">۷. غلبه بر ترس از طرد شدن</h4>
            <p>
              برای رشد واقعی، باید آماده «نه» شنیدن باشید. هر High I موفقی آموخته است که تأیید همیشگی ممکن نیست؛ اما این مانع ادامه مسیرش نمی‌شود.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۸. انتخاب کمتر، ولی پایدارتر</h4>
            <p>
              همه کارها را نپذیرید. به‌جای ۱۰ کار نیمه‌کاره، ۳ کار کامل‌شده داشته باشید. قانون طلایی موفقیت High Iها «کمتر، اما عمیق‌تر» است.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">جمع‌بندی</h4>
            <p>
              رمز موفقیت High I در این جمله نهفته است:
            </p>
            <p className="mt-2">
              شما ذاتاً ستاره هستید، اما با تمرین نظم، تعهد، خودشناسی و هدفمندی، به خورشید تبدیل می‌شوید.
            </p>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            افراد با تیپ High I برای دستیابی به تعادل رفتاری و موفقیت پایدار، نیاز دارند برخی ویژگی‌های تیپ‌های دیگر را آگاهانه در خود تقویت کنند. این فرآیند «افزایش انعطاف رفتاری» است و کمک می‌کند در موقعیت‌های مختلف، به‌جای واکنش‌ هیجانی یا یک‌بعدی، انتخابی و متناسب عمل کنند.
          </p>

          <div className="space-y-4">
            <div>
              <h4 className="font-semibold mb-2">۱. تقویت لایه D — تسلط و قاطعیت</h4>
              <p>
                High Iها معمولاً از تقابل مستقیم پرهیز می‌کنند و ترجیح می‌دهند همه‌چیز را با لبخند حل کنند. اما گاهی لازم است قاطع، سرراست و مقتدرانه رفتار کنند، مخصوصاً در مواجهه با افراد فرصت‌طلب یا موقعیت‌های تصمیم‌گیری سریع.
              </p>

              <div className="mt-2 space-y-2">
                <p className="font-medium">راهکارها:</p>
                <ul className="list-disc pr-5 space-y-1">
                  <li>از کلماتی مانند «قاطعیت»، «تصمیم»، «نتیجه» و «اقدام سریع» بیشتر استفاده کنید.</li>
                  <li>به خودتان اجازه دهید گاهی «نه» بگویید، حتی اگر نگران واکنش دیگران هستید.</li>
                  <li>در برنامه‌ریزی، اهداف را کمی چالشی و مشخص با ددلاین تعیین کنید.</li>
                </ul>
                <p className="mt-2">
                  <span className="font-medium">جمله تمرینی:</span> «من مسئول این نتیجه‌ام و باید تصمیم بگیرم، حتی اگر خوشایند همه نباشد.»
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۲. تقویت لایه S — ثبات و همکاری آرام</h4>
              <p>
                High I گاهی بیش‌ازحد پرجنب‌وجوش یا احساساتی است. تیپ S به او یاد می‌دهد که گاهی باید آرام، باثبات، با ملاحظه و شنوا بود، بدون نیاز به جلب توجه.
              </p>

              <div className="mt-2 space-y-2">
                <p className="font-medium">راهکارها:</p>
                <ul className="list-disc pr-5 space-y-1">
                  <li>از کلماتی مثل «صبوری»، «آرامش»، «همدلی» و «همراهی» بیشتر استفاده کنید.</li>
                  <li>تمرین کنید در گفتگوها فقط گوش دهید، بدون قطع یا واکنش سریع.</li>
                  <li>به‌جای شوخی، گاهی با حضور ساکت و حمایتگر کنار دوستان باشید.</li>
                </ul>
                <p className="mt-2">
                  <span className="font-medium">جمله تمرینی:</span> «من لازم نیست همیشه حرف بزنم تا مؤثر باشم، گاهی فقط حضور، قدرت دارد.»
                </p>
              </div>
            </div>

          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
      >
        <div className='text-gray-800'>
          <h4 className="font-semibold mb-2">۳. تقویت لایه C — دقت، منطق، تحلیل</h4>
          <p>
            بزرگ‌ترین نقطه ضعف رفتاری High I، بی‌توجهی به جزئیات و منطق است. در حالی‌که لایه C دقیقاً این را به او یاد می‌دهد: بررسی، تعمق، تحلیل و پایبندی به ساختار.
          </p>

          <div className="mt-2 space-y-2">
            <p className="font-medium">راهکارها:</p>
            <ul className="list-disc pr-5 space-y-1">
              <li>از عباراتی مثل «بررسی مجدد»، «تحلیل منطقی» و «اطمینان از جزئیات» زیاد استفاده کنید.</li>
              <li>قبل از ارائه یک ایده، از خود بپرسید: آیا مستند است؟ داده دارد؟ قابل دفاع است؟</li>
              <li>تمرین کنید یک پروژه را فقط از بُعد «اشتباهات احتمالی» نگاه کنید.</li>
            </ul>
            <p className="mt-2">
              <span className="font-medium">جمله تمرینی:</span> «اگر می‌خواهم تأثیر واقعی بگذارم، باید جزئیات را مثل کل، جدی بگیرم.»
            </p>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="کلمات و جملات گفتار روزانه یک High I"
      >
        <p className="text-gray-800 leading-7">
          قاطعیت، تصمیم، نتیجه‌گرایی، مسئولیت لایه D
          صبوری، گوش دادن، آرامش، هماهنگی، حمایت لایه S
          بررسی، تحلیل، منطق، دقت، ساختار لایه C
          تکرار مؤثر برای خودآگاهی رفتاری:
          «من ذاتاً الهام‌بخشم، اما با نظم و منطق، تأثیرم ماندگار می‌شود.»
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            افراد با الگوی High I از نظر ذاتی در تعامل، انرژی‌دهی و تأثیرگذاری اجتماعی بسیار قدرتمند هستند. اما برای آن‌که بتوانند در مسیر شغلی و فردی رشد پایدار داشته باشند، نیاز به مجموعه‌ای از مهارت‌های «تکمیل‌کننده» دارند؛ مهارت‌هایی که نقاط ضعف رفتاری‌شان را پوشش دهد و نقاط قوت‌شان را هدفمند کند.
          </p>

          <div className="space-y-4">
            <div>
              <h4 className="font-semibold mb-2">۱. مدیریت زمان و اولویت‌بندی</h4>
              <p>
                برای High I که ذهن پرپرشی دارد و چندین کار را هم‌زمان آغاز می‌کند، یادگیری روش‌هایی مانند تکنیک پومودورو، استفاده از تقویم هفتگی و ایجاد لیست اهداف روزانه کاملاً ضروری است.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۲. تمرکز و پیگیری تا پایان پروژه</h4>
              <p>
                مهم است که High I بیاموزد چگونه پروژه‌ها را تا انتها ادامه دهد. تمرین نظم شخصی، همکاری با یک همکار پیگیر مثل تیپ C یا S و استفاده از ابزارهای ردیابی پروژه به او کمک می‌کند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۳. هوش هیجانی (EQ)</h4>
              <p>
                توانایی تشخیص هیجانات خود، مدیریت آن‌ها، شناخت احساسات دیگران و واکنش متناسب در موقعیت‌های مختلف، از حیاتی‌ترین مهارت‌های مورد نیاز این تیپ است.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۴. نه گفتن و جرأت‌ورزی محترمانه</h4>
              <p>
                High Iها معمولاً برای حفظ رابطه، درخواست‌ها را به‌راحتی می‌پذیرند. یادگیری نه گفتن با احترام و تعیین مرزهای روانی، یکی از بزرگ‌ترین گام‌های رشدی آن‌هاست.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۵. مهارت تصمیم‌گیری منطقی</h4>
              <p>
                آن‌ها باید یاد بگیرند احساس را با منطق ترکیب کنند. آموزش چارچوب‌هایی مثل تحلیل SWOT شخصی، تکنیک ۱۰-۱۰-۱۰ (چه اتفاقی در ۱۰ دقیقه، ۱۰ ماه و ۱۰ سال بعد می‌افتد؟) یا ماتریس تصمیم‌گیری کمک زیادی می‌کند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۶. تفکر نقادانه و تحلیل داده‌ها</h4>
              <p>
                توانایی تفکیک واقعیت از هیجان، ارزیابی مستندات، تحلیل گزارش‌ها و طراحی مسیر اجرایی از جمله مهارت‌هایی است که یک High I را به رهبر قابل اتکا تبدیل می‌کند.
              </p>
            </div>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title=""
      >
        <div className="text-gray-800 space-y-4">
          <div>
            <h4 className="font-semibold mb-2">۷. گوش دادن فعال و کنترل کلام</h4>
            <p>
              یاد بگیرد چگونه شنیدن مؤثر داشته باشد، مکث کند و پاسخ را با عمق بدهد. این مهارت، قدرت تأثیر او را چند برابر می‌کند.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۸. مهارت در ارائه و بیان ساختاریافته</h4>
            <p>
              بیان پرانرژی خوب است، اما ارائه با ساختار و هدف بهتر است. High I می‌تواند با یادگیری طراحی پیام، سناریونویسی ارائه و استفاده از ابزارهای بصری، جذابیت ذاتی خود را به نتیجه‌ای قابل دفاع تبدیل کند.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۹. کنترل هیجانات و مدیریت استرس</h4>
            <p>
              تیپ I معمولاً در شرایط فشار یا طرد دچار افت شدید انرژی می‌شود. یادگیری تکنیک‌هایی مثل تنفس آگاهانه، نوشتن، ورزش و مراقبه می‌تواند به حفظ تعادل درونی کمک کند.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۱۰. سازگاری با تیپ‌های متفاوت رفتاری</h4>
            <p>
              او باید بیاموزد با تیپ‌های C تحلیلی و دقیق، D قاطع و نتیجه‌محور و S آرام و باثبات چگونه مؤثر و همدلانه کار کند.
            </p>
          </div>
        </div>
      </Page>


      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            افراد با تیپ High I بیش از هر چیز در مشاغلی موفق هستند که بتوانند در آن‌ها:
          </p>

          <ul className="list-disc pr-5 space-y-1">
            <li>با دیگران در ارتباط باشند</li>
            <li>تعاملات انسانی پویایی داشته باشند</li>
            <li>دیده شوند و تأثیرگذار باشند</li>
            <li>و فضایی برای خلاقیت، ایده‌پردازی و هیجان وجود داشته باشد</li>
          </ul>

          <p>
            در ادامه، فهرستی از مشاغل مناسب به همراه توضیح تطبیقی برای هرکدام آمده است:
          </p>

          <div className="space-y-4">
            <div>
              <h4 className="font-semibold mb-2">۱. مشاور و مربی رشد فردی (کوچ، تراپیست، منتور)</h4>
              <p>
                شنونده‌های گرم و الهام‌بخشی هستند. آن‌ها با انرژی مثبت، حس اعتماد و انگیزه را در مراجعان ایجاد می‌کنند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۲. مدرس و سخنران انگیزشی</h4>
              <p>
                توانایی بیان، داستان‌سرایی و انتقال هیجان در High Iها آن‌ها را برای تدریس و سخنرانی جذاب می‌سازد، به‌ویژه در حوزه‌هایی مانند مهارت‌های زندگی، فروش، رشد فردی یا ارتباط مؤثر.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۳. مسئول یا مدیر روابط عمومی و ارتباط با مشتری</h4>
              <p>
                این افراد در مدیریت ارتباطات، مذاکره، حل اختلاف و ایجاد رابطه‌های بلندمدت بسیار موفق عمل می‌کنند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۴. فروشنده حرفه‌ای / مشاور فروش برندهای خلاق</h4>
              <p>
                این افراد با شوخ‌طبعی، بیان قوی و انرژی خود می‌توانند به‌راحتی ذهن مشتری را درگیر کرده و فرآیند فروش را تسهیل کنند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۵. مدیر یا تسهیل‌گر منابع انسانی (HR)</h4>
              <p>
                در جذب نیرو، مصاحبه، آموزش درون‌سازمانی یا مدیریت روابط کارمندان، High Iها می‌توانند فضا را زنده، انسانی و صمیمی نگه دارند.
              </p>
            </div>

          </div>
        </div>
      </Page>


      <Page
        testResult={testResult}
        title=""
      >
        <div className="text-gray-800 space-y-4">
          <div>
            <h4 className="font-semibold mb-2">۶. گرافیست، طراح تبلیغاتی یا مدیر کمپین‌های خلاقانه</h4>
            <p>
              تیپ I عاشق رنگ، خلاقیت و ایده‌های نو است. اگر در طراحی مهارت داشته باشد، می‌تواند کمپین‌های بسیار جذابی خلق کند، به‌ویژه در حوزه برندینگ.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۷. برگزارکننده رویدادها، کنفرانس‌ها و همایش‌ها</h4>
            <p>
              در سازماندهی، هماهنگی مهمان‌ها، اجرای برنامه و مدیریت فضای زنده، High Iها استادان ذاتی هستند.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۸. راهنمای تور، لیدر گردشگری، مدیر سفرهای سازمانی</h4>
            <p>
              ترکیب انرژی، تعامل انسانی، داستان‌گویی و تحمل محیط‌های متغیر، این تیپ را برای مشاغل گردشگری و ارتباطی بسیار مناسب می‌کند.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۹. کارآفرین در حوزه خدمات، آموزش یا سرگرمی</h4>
            <p>
              اگر High I ذهن تجاری هم داشته باشد، کارآفرینی در حوزه‌هایی با تنوع بالا، تعامل زیاد و بازخوردهای سریع، او را به موفقیت می‌رساند.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">نکته مهم</h4>
            <p>
              برای پیشنهاد شغلی به تیپ High I فقط به «جذابیت اولیه» شغل اکتفا نکنید. بررسی کنید آیا فازهای پیگیری و جزئیات آن کار با توانایی‌هایش هماهنگ است یا خیر. در غیر این‌صورت، بهتر است با تیپ مکمل در آن شغل همراه شود.
            </p>
          </div>
        </div>
      </Page>


      <Page
        testResult={testResult}
        title="همسر مناسب و نحوه ارتباط مؤثر با او"
      >
        <p className="text-gray-800 leading-7">
          فرد  High I در زندگی زناشویی، شخصیتی گرم، عاشق‌پیشه، پرانرژی و اجتماعی دارد. اما در عین حال ممکن است گاهی بی‌برنامه، هیجانی، فراموش‌کار یا احساساتی باشد. بنابراین، انتخاب همسر برای او و نحوه تعامل در رابطه، باید با درک این ویژگی‌ها انجام گیرد.

        </p>
      </Page>


      <Page
        testResult={testResult}
        title="ویژگی‌های شخصیتی مناسب همسر فرد High I"
      >
        <p className="text-gray-800 leading-7">
          صبور و شنوا باشد، تا بتواند با پرحرفی، هیجان و نوسانات روحی  High I کنار بیاید.
          ساختارده و منظم باشد، تا مکمل ضعف‌های اجرایی و پیگیری این تیپ شود.
          از تحسین کردن خسته نشود، چرا که  High I نیازمند بازخورد مثبت و دیده‌شدن است.
          امنیت روانی و ثبات عاطفی ایجاد کند، تا وقتی  High I دچار آشفتگی یا بی‌برنامگی می‌شود، پناهگاه آرامش باشد.
          ترجیحاً از تیپ‌های S، C  یا حتی D  آرام و اهل عمل باشد که بتواند عمق و استمرار را وارد رابطه کند.

        </p>
      </Page>


      <Page
        testResult={testResult}
        title="نکاتی که همسر فرد High I باید بداند"
      >
        <p className="text-gray-800 leading-7">
          او ممکن است گاهی پرانرژی و پرحرف، بی‌تمرکز و فراموش‌کار باشد؛ این نوسان طبیعی است، نه بی‌احترامی.
          اگر احساس کند نادیده گرفته شده یا مورد انتقاد قرار گرفته، احتمال دارد رفتارش کودکانه، بسته یا دفاعی شود.
          باید مرتباً از او بازخورد مثبت بگیرید، حتی برای کارهای ساده. جمله‌هایی مثل «واقعاً خوش‌برخوردی»، «حرف‌هات الهام‌بخشه» معجزه می‌کند.
          او عاشق خلاقیت و تنوع در رابطه است، مثل سورپرایزهای کوچک، مسافرت‌های دونفره، یا حرف‌های غافلگیرکننده.
          در دعوا یا بحث، احتمال دارد هیجانی، شتاب‌زده یا حتی نمایشی رفتار کند—بهتر است در این مواقع آرام و ساختارمند با او گفت‌وگو شود، نه متقابل هیجانی.
        </p>
      </Page>


      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند"
      >
        <p className="text-gray-800 leading-7">
          به احساسات، نیازها و سکوت‌های همسرتان توجه کنید، نه فقط کلمات و انرژی بیرونی او.
          هرچه را فکر می‌کنید لازم نیست بگویید؛ بعضی حرف‌ها باید صبر کنند.
          گاهی سکوت، حضور آرام، یا عمل‌کردن بدون نمایش، زیباترین ابزار محبت است.
          برنامه‌ریزی، پیگیری وظایف خانه، یا ایفای نقش‌های مسئولانه را تمرین کنید، محبوبیت بدون مسئولیت، دوام ندارد.
          اگر مورد انتقاد قرار گرفتید، گوش کنید، نه‌ اینکه سریع توجیه یا دفاع کنید.
          شریک عاطفی شما همیشه نیازی به «تشویق‌ شدن» ندارد، گاهی نیاز به همدلی و ثبات آرام دارد.
        </p>

        <p className="text-gray-800 leading-7">
          <strong> مثال واقعی :</strong>
          <br />
          یک خانم  High I که بسیار اجتماعی، پرانرژی و پرحرف بود، در زندگی با همسری آرام و درون‌گرا High S/High C دچار چالش شده بود. وقتی فهمید همسرش در سکوت و رفتار آرامش، محبت را نشان می‌دهد (نه در کلمات)، و خود نیز یاد گرفت هر شب همه هیجانات را بی‌فیلتر بیرون نریزد، رابطه آن‌ها متحول شد.
          فیلم پیشنهادی برای درک بهتر روابط  High I :
          "The Intern"  کارآموز با بازی رابرت دنیرو و آن هاتاوی، تعامل بین کاراکتری پرانرژی و هیجانی با شخصیتی آرام و متین را به‌زیبایی نشان می‌دهد
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین High I با فرزندان و بالعکس"
      >
        <p className="text-gray-800 leading-7">
          والدین با تیپ  High I، معمولاً والدینی مهربان، پرشور، خوش‌برخورد و دوستانه هستند. خانه را پر از خنده، انرژی و گفت‌وگو می‌کنند. اما همین سبک در صورت بی‌تعادل شدن، ممکن است منجر به بی‌برنامگی، عدم مرزبندی یا ضعف در اعمال اقتدار والدگری شود.

        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های والد  High I در تعامل با فرزندان"
      >
        <p className="text-gray-800 leading-7">
          صمیمی، بازیگوش و اهل گفت‌وگو
          علاقه‌مند به تشویق، برقراری رابطه گرم و دوستانه
          گاهی بدون برنامه، بدون قاطعیت و احساسی در تربیت
          در لحظه تصمیم‌گیر، با نوسانات هیجانی زیاد
          مشتاق دیده‌شدن و دوست‌داشتنی بودن حتی از سوی فرزندان (گاهی بیش از حد)
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="والد High I برای ارتباط مؤثر با فرزندان چه کند؟"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <div>
            <h4 className="font-semibold mb-2">۱. در عین محبت، مرزها را حفظ کند</h4>
            <p>
              اگر همه‌چیز با خنده و انعطاف مدیریت شود، کودک نظم و اقتدار را درک نمی‌کند. قاطعیت مهربانانه را یاد بگیرید.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۲. قول ندهد، اگر نمی‌خواهد عمل کند</h4>
            <p>
              والد High I ممکن است از روی هیجان قول‌هایی بدهد که بعداً فراموش می‌شوند، و این اعتماد فرزند را از بین می‌برد.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۳. الگوی تعهد و پیگیری باشد</h4>
            <p>
              کودک نباید فقط شور و خنده را از والدش یاد بگیرد؛ بلکه باید ببیند چگونه کاری را تا آخر پیش می‌برد.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۴. با هیجان‌های کودک همدل باشد، اما غرق نشود</h4>
            <p>
              گاهی کودک خشمگین، غمگین یا مضطرب است. والد High I ممکن است بخواهد فضا را سریع عوض کند. گاهی باید فقط شنید، در آغوش گرفت، بدون شوخی یا منحرف کردن.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۵. برنامه‌ریزی و ثبات را تمرین کند</h4>
            <p>
              برای خواب، مطالعه، بازی، تغذیه و حتی محبت، برنامه داشته باشد. این باعث امنیت کودک می‌شود.
            </p>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="فرزندان والد High I باید چه چیزهایی را بدانند؟"
      >
        <p className="text-gray-800 leading-7">
          اگر پدر یا مادرت پرانرژی، شوخ و گاهی بی‌برنامه است، این بخشی از شخصیتش است، نه بی‌مسئولیتی.
          گاهی او نیاز دارد سکوت یا نظم را از تو یاد بگیرد، پس با آرامش به او یادآوری کن.
          <br />
          اگر قولی داد و عمل نکرد، محترمانه یادآور شو—ولی با قهر یا کنایه او را از خودت دور نکن.
          پدر/مادر  High I معمولاً زود عصبانی می‌شود، ولی زود هم پشیمان می‌شود؛ پس دلخوری را زیاد نکن.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تمارینی برای تعادل هیجانی والد High I"
      >
        <p className="text-gray-800 leading-7">
          یادداشت روزانه درباره رفتار با فرزند
          گفت‌وگوی شبانه ۵ دقیقه‌ای با کودک بدون گوشی یا حواس‌پرتی
          طراحی جدول پیگیری قول‌ها و رفتارهای توافقی
          استفاده از ابزارهایی مثل «تقویم ارتباطی خانوادگی» یا «دفتر خشم و شادی»
          مثال کاربردی: مادری با تیپ  High I که هر بار از فرزندش قول می‌گرفت، ولی پیگیری نمی‌کرد. با افزودن یک «تابلوی خانگی پیگیری رفتار» و مشارکت دادن فرزند در طراحی آن، توانست اعتماد و ساختار را وارد رابطه کند،بدون اینکه از انرژی مثبتش کم شود.

        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رفتار مؤثر فرزندان با والد High I"
      >
        <div className="text-gray-800 leading-7 space-y-4">
          <p>
            والدینی با تیپ High I معمولاً شاد، پرانرژی، پرحرف، گرم و دوستانه‌اند. آن‌ها بیش از آن‌که بخواهند اقتدارشان را به رخ بکشند، دنبال رابطه‌ای صمیمی با فرزندان هستند. اما این سبک ممکن است برای فرزندی با تیپ منطقی یا درون‌گرا چالش‌هایی ایجاد کند؛ یا موجب شود کودک، والدش را گاهی بی‌ثبات یا بدون اقتدار ببیند.
          </p>

          <div className="space-y-4">
            <div>
              <h4 className="font-semibold mb-2">۱. با او گفت‌وگو کن، حتی وقتی بی‌انرژی است</h4>
              <p>
                والد High I معمولاً خودش اهل حرف زدن است؛ اما وقتی ساکت است، به این معنا نیست که نمی‌خواهد حرف بزند. در آن لحظات، شروع گفت‌وگو از سمت تو می‌تواند رابطه را بازسازی کند.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۲. در یادآوری وظایف یا قول‌هایش، مهربان ولی پیگیر باش</h4>
              <p>
                اگر گفت «بریم سینما»، ولی یادت رفت یادآوری کنی، ممکن است فراموش کند، نه از روی بی‌احترامی، بلکه از روی ذهن پرشور و پر‌مشغله‌اش. جملات ساده، مستقیم و بدون کنایه به او کمک می‌کند:
                <br />
                «مامان، گفتی این هفته سینما می‌ریم. هنوز سر قراری؟»
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۳. وقتی ناراحتی، او را غافلگیر نکن، آگاهانه حرفت را بزن</h4>
              <p>
                ممکن است والد High I به اشتباهی بخندد یا آن را شوخی بگیرد. تو باید جدی بودن احساساتت را به‌صراحت بگویی:
                <br />
                «بابا، این دفعه واقعاً ناراحت شدم. لطفاً گوش کن. الان نیاز به شوخی ندارم.»
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۴. به فضای هیجانی او احترام بگذار، ولی از خودت رد نشو</h4>
              <p>
                اگر والدت هیجان‌زده، پرصدا یا شلوغ است، این سبک خودش است. اما تو اگر نیاز به آرامش داری، می‌توانی محترمانه محدوده خودت را تعریف کنی:
                <br />
                «می‌دونم انرژی داری، ولی من الان ترجیح می‌دم ساکت باشم. بعداً حرف بزنیم؟»
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">۵. از علاقه‌اش به تحسین استفاده کن تا تربیت معکوس کنی</h4>
              <p>
                مثلاً وقتی وظیفه‌ای را انجام داد، با تحسین مثبت آن را تثبیت کن:
                <br />
                «دمت گرم بابا، امروز زود اومدی خونه. خیلی کیف کردم. همین خیلی برام مهم بود.»
              </p>
            </div>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title=""
      >
        <div className="text-gray-800 space-y-4">

          <div>
            <h4 className="font-semibold mb-2">۶. اگر دعوا کرد یا واکنش هیجانی داشت، زود دلش را به‌دست بیاور</h4>
            <p>
              والد High I معمولاً زود عصبانی می‌شود، ولی زود هم پشیمان است. با یک جمله دوستانه، دوباره فضا را بساز:
              <br />
              «مامان، می‌دونم از دستم ناراحت شدی، ولی دلم نمی‌خواد فاصله بیفته بینمون.»
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">۷. برای صحبت درباره مسائل مهم، زمان و فضای مناسب را انتخاب کن</h4>
            <p>
              نه وسط خرید، نه در جمع، نه وقتی گوشی دستش است. High I اگر حواسش جمع باشد، شنونده بسیار خوبی است، فقط باید زمان را هوشمندانه انتخاب کنی.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-2">جمع‌بندی</h4>
            <p>
              فرزندان باید یاد بگیرند که والد High I مانند باد گرم است: اگر هدایتش کنند، بادبان می‌برد؛ اگر رها بگذارند، ممکن است گردباد شود. با گفتگو، شفافیت، احترام و پیگیری آرام، می‌توانند رابطه‌ای زیبا و اثرگذار بسازند.
            </p>
          </div>
        </div>
      </Page>
    </>
  )
}

export default HighI